import "@inmar/hcds-lit/Icon";
//#region ../../node_modules/@lit/reactive-element/css-tag.js
var e = globalThis, t = e.ShadowRoot && (e.ShadyCSS === void 0 || e.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, n = Symbol(), r = /* @__PURE__ */ new WeakMap(), i = class {
	constructor(e, t, r) {
		if (this._$cssResult$ = !0, r !== n) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
		this.cssText = e, this.t = t;
	}
	get styleSheet() {
		let e = this.o, n = this.t;
		if (t && e === void 0) {
			let t = n !== void 0 && n.length === 1;
			t && (e = r.get(n)), e === void 0 && ((this.o = e = new CSSStyleSheet()).replaceSync(this.cssText), t && r.set(n, e));
		}
		return e;
	}
	toString() {
		return this.cssText;
	}
}, a = (e) => new i(typeof e == "string" ? e : e + "", void 0, n), o = (e, ...t) => new i(e.length === 1 ? e[0] : t.reduce((t, n, r) => t + ((e) => {
	if (!0 === e._$cssResult$) return e.cssText;
	if (typeof e == "number") return e;
	throw Error("Value passed to 'css' function must be a 'css' function result: " + e + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
})(n) + e[r + 1], e[0]), e, n), s = (n, r) => {
	if (t) n.adoptedStyleSheets = r.map((e) => e instanceof CSSStyleSheet ? e : e.styleSheet);
	else for (let t of r) {
		let r = document.createElement("style"), i = e.litNonce;
		i !== void 0 && r.setAttribute("nonce", i), r.textContent = t.cssText, n.appendChild(r);
	}
}, c = t ? (e) => e : (e) => e instanceof CSSStyleSheet ? ((e) => {
	let t = "";
	for (let n of e.cssRules) t += n.cssText;
	return a(t);
})(e) : e, { is: l, defineProperty: u, getOwnPropertyDescriptor: d, getOwnPropertyNames: ee, getOwnPropertySymbols: te, getPrototypeOf: ne } = Object, f = globalThis, re = f.trustedTypes, ie = re ? re.emptyScript : "", ae = f.reactiveElementPolyfillSupport, p = (e, t) => e, m = {
	toAttribute(e, t) {
		switch (t) {
			case Boolean:
				e = e ? ie : null;
				break;
			case Object:
			case Array: e = e == null ? e : JSON.stringify(e);
		}
		return e;
	},
	fromAttribute(e, t) {
		let n = e;
		switch (t) {
			case Boolean:
				n = e !== null;
				break;
			case Number:
				n = e === null ? null : Number(e);
				break;
			case Object:
			case Array: try {
				n = JSON.parse(e);
			} catch {
				n = null;
			}
		}
		return n;
	}
}, h = (e, t) => !l(e, t), oe = {
	attribute: !0,
	type: String,
	converter: m,
	reflect: !1,
	useDefault: !1,
	hasChanged: h
};
Symbol.metadata ??= Symbol("metadata"), f.litPropertyMetadata ??= /* @__PURE__ */ new WeakMap();
var g = class extends HTMLElement {
	static addInitializer(e) {
		this._$Ei(), (this.l ??= []).push(e);
	}
	static get observedAttributes() {
		return this.finalize(), this._$Eh && [...this._$Eh.keys()];
	}
	static createProperty(e, t = oe) {
		if (t.state && (t.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(e) && ((t = Object.create(t)).wrapped = !0), this.elementProperties.set(e, t), !t.noAccessor) {
			let n = Symbol(), r = this.getPropertyDescriptor(e, n, t);
			r !== void 0 && u(this.prototype, e, r);
		}
	}
	static getPropertyDescriptor(e, t, n) {
		let { get: r, set: i } = d(this.prototype, e) ?? {
			get() {
				return this[t];
			},
			set(e) {
				this[t] = e;
			}
		};
		return {
			get: r,
			set(t) {
				let a = r?.call(this);
				i?.call(this, t), this.requestUpdate(e, a, n);
			},
			configurable: !0,
			enumerable: !0
		};
	}
	static getPropertyOptions(e) {
		return this.elementProperties.get(e) ?? oe;
	}
	static _$Ei() {
		if (this.hasOwnProperty(p("elementProperties"))) return;
		let e = ne(this);
		e.finalize(), e.l !== void 0 && (this.l = [...e.l]), this.elementProperties = new Map(e.elementProperties);
	}
	static finalize() {
		if (this.hasOwnProperty(p("finalized"))) return;
		if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(p("properties"))) {
			let e = this.properties, t = [...ee(e), ...te(e)];
			for (let n of t) this.createProperty(n, e[n]);
		}
		let e = this[Symbol.metadata];
		if (e !== null) {
			let t = litPropertyMetadata.get(e);
			if (t !== void 0) for (let [e, n] of t) this.elementProperties.set(e, n);
		}
		this._$Eh = /* @__PURE__ */ new Map();
		for (let [e, t] of this.elementProperties) {
			let n = this._$Eu(e, t);
			n !== void 0 && this._$Eh.set(n, e);
		}
		this.elementStyles = this.finalizeStyles(this.styles);
	}
	static finalizeStyles(e) {
		let t = [];
		if (Array.isArray(e)) {
			let n = new Set(e.flat(Infinity).reverse());
			for (let e of n) t.unshift(c(e));
		} else e !== void 0 && t.push(c(e));
		return t;
	}
	static _$Eu(e, t) {
		let n = t.attribute;
		return !1 === n ? void 0 : typeof n == "string" ? n : typeof e == "string" ? e.toLowerCase() : void 0;
	}
	constructor() {
		super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
	}
	_$Ev() {
		this._$ES = new Promise((e) => this.enableUpdating = e), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((e) => e(this));
	}
	addController(e) {
		(this._$EO ??= /* @__PURE__ */ new Set()).add(e), this.renderRoot !== void 0 && this.isConnected && e.hostConnected?.();
	}
	removeController(e) {
		this._$EO?.delete(e);
	}
	_$E_() {
		let e = /* @__PURE__ */ new Map(), t = this.constructor.elementProperties;
		for (let n of t.keys()) this.hasOwnProperty(n) && (e.set(n, this[n]), delete this[n]);
		e.size > 0 && (this._$Ep = e);
	}
	createRenderRoot() {
		let e = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
		return s(e, this.constructor.elementStyles), e;
	}
	connectedCallback() {
		this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((e) => e.hostConnected?.());
	}
	enableUpdating(e) {}
	disconnectedCallback() {
		this._$EO?.forEach((e) => e.hostDisconnected?.());
	}
	attributeChangedCallback(e, t, n) {
		this._$AK(e, n);
	}
	_$ET(e, t) {
		let n = this.constructor.elementProperties.get(e), r = this.constructor._$Eu(e, n);
		if (r !== void 0 && !0 === n.reflect) {
			let i = (n.converter?.toAttribute === void 0 ? m : n.converter).toAttribute(t, n.type);
			this._$Em = e, i == null ? this.removeAttribute(r) : this.setAttribute(r, i), this._$Em = null;
		}
	}
	_$AK(e, t) {
		let n = this.constructor, r = n._$Eh.get(e);
		if (r !== void 0 && this._$Em !== r) {
			let e = n.getPropertyOptions(r), i = typeof e.converter == "function" ? { fromAttribute: e.converter } : e.converter?.fromAttribute === void 0 ? m : e.converter;
			this._$Em = r;
			let a = i.fromAttribute(t, e.type);
			this[r] = a ?? this._$Ej?.get(r) ?? a, this._$Em = null;
		}
	}
	requestUpdate(e, t, n, r = !1, i) {
		if (e !== void 0) {
			let a = this.constructor;
			if (!1 === r && (i = this[e]), n ??= a.getPropertyOptions(e), !((n.hasChanged ?? h)(i, t) || n.useDefault && n.reflect && i === this._$Ej?.get(e) && !this.hasAttribute(a._$Eu(e, n)))) return;
			this.C(e, t, n);
		}
		!1 === this.isUpdatePending && (this._$ES = this._$EP());
	}
	C(e, t, { useDefault: n, reflect: r, wrapped: i }, a) {
		n && !(this._$Ej ??= /* @__PURE__ */ new Map()).has(e) && (this._$Ej.set(e, a ?? t ?? this[e]), !0 !== i || a !== void 0) || (this._$AL.has(e) || (this.hasUpdated || n || (t = void 0), this._$AL.set(e, t)), !0 === r && this._$Em !== e && (this._$Eq ??= /* @__PURE__ */ new Set()).add(e));
	}
	async _$EP() {
		this.isUpdatePending = !0;
		try {
			await this._$ES;
		} catch (e) {
			Promise.reject(e);
		}
		let e = this.scheduleUpdate();
		return e != null && await e, !this.isUpdatePending;
	}
	scheduleUpdate() {
		return this.performUpdate();
	}
	performUpdate() {
		if (!this.isUpdatePending) return;
		if (!this.hasUpdated) {
			if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
				for (let [e, t] of this._$Ep) this[e] = t;
				this._$Ep = void 0;
			}
			let e = this.constructor.elementProperties;
			if (e.size > 0) for (let [t, n] of e) {
				let { wrapped: e } = n, r = this[t];
				!0 !== e || this._$AL.has(t) || r === void 0 || this.C(t, void 0, n, r);
			}
		}
		let e = !1, t = this._$AL;
		try {
			e = this.shouldUpdate(t), e ? (this.willUpdate(t), this._$EO?.forEach((e) => e.hostUpdate?.()), this.update(t)) : this._$EM();
		} catch (t) {
			throw e = !1, this._$EM(), t;
		}
		e && this._$AE(t);
	}
	willUpdate(e) {}
	_$AE(e) {
		this._$EO?.forEach((e) => e.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(e)), this.updated(e);
	}
	_$EM() {
		this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
	}
	get updateComplete() {
		return this.getUpdateComplete();
	}
	getUpdateComplete() {
		return this._$ES;
	}
	shouldUpdate(e) {
		return !0;
	}
	update(e) {
		this._$Eq &&= this._$Eq.forEach((e) => this._$ET(e, this[e])), this._$EM();
	}
	updated(e) {}
	firstUpdated(e) {}
};
g.elementStyles = [], g.shadowRootOptions = { mode: "open" }, g[p("elementProperties")] = /* @__PURE__ */ new Map(), g[p("finalized")] = /* @__PURE__ */ new Map(), ae?.({ ReactiveElement: g }), (f.reactiveElementVersions ??= []).push("2.1.2");
//#endregion
//#region ../../node_modules/lit-html/lit-html.js
var _ = globalThis, se = (e) => e, v = _.trustedTypes, ce = v ? v.createPolicy("lit-html", { createHTML: (e) => e }) : void 0, le = "$lit$", y = `lit$${Math.random().toFixed(9).slice(2)}$`, b = "?" + y, ue = `<${b}>`, x = document, S = () => x.createComment(""), C = (e) => e === null || typeof e != "object" && typeof e != "function", w = Array.isArray, de = (e) => w(e) || typeof e?.[Symbol.iterator] == "function", T = "[ 	\n\f\r]", E = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, fe = /-->/g, pe = />/g, D = RegExp(`>|${T}(?:([^\\s"'>=/]+)(${T}*=${T}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), me = /'/g, he = /"/g, ge = /^(?:script|style|textarea|title)$/i, O = ((e) => (t, ...n) => ({
	_$litType$: e,
	strings: t,
	values: n
}))(1), k = Symbol.for("lit-noChange"), A = Symbol.for("lit-nothing"), _e = /* @__PURE__ */ new WeakMap(), j = x.createTreeWalker(x, 129);
function ve(e, t) {
	if (!w(e) || !e.hasOwnProperty("raw")) throw Error("invalid template strings array");
	return ce === void 0 ? t : ce.createHTML(t);
}
var ye = (e, t) => {
	let n = e.length - 1, r = [], i, a = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", o = E;
	for (let t = 0; t < n; t++) {
		let n = e[t], s, c, l = -1, u = 0;
		for (; u < n.length && (o.lastIndex = u, c = o.exec(n), c !== null);) u = o.lastIndex, o === E ? c[1] === "!--" ? o = fe : c[1] === void 0 ? c[2] === void 0 ? c[3] !== void 0 && (o = D) : (ge.test(c[2]) && (i = RegExp("</" + c[2], "g")), o = D) : o = pe : o === D ? c[0] === ">" ? (o = i ?? E, l = -1) : c[1] === void 0 ? l = -2 : (l = o.lastIndex - c[2].length, s = c[1], o = c[3] === void 0 ? D : c[3] === "\"" ? he : me) : o === he || o === me ? o = D : o === fe || o === pe ? o = E : (o = D, i = void 0);
		let d = o === D && e[t + 1].startsWith("/>") ? " " : "";
		a += o === E ? n + ue : l >= 0 ? (r.push(s), n.slice(0, l) + le + n.slice(l) + y + d) : n + y + (l === -2 ? t : d);
	}
	return [ve(e, a + (e[n] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), r];
}, M = class e {
	constructor({ strings: t, _$litType$: n }, r) {
		let i;
		this.parts = [];
		let a = 0, o = 0, s = t.length - 1, c = this.parts, [l, u] = ye(t, n);
		if (this.el = e.createElement(l, r), j.currentNode = this.el.content, n === 2 || n === 3) {
			let e = this.el.content.firstChild;
			e.replaceWith(...e.childNodes);
		}
		for (; (i = j.nextNode()) !== null && c.length < s;) {
			if (i.nodeType === 1) {
				if (i.hasAttributes()) for (let e of i.getAttributeNames()) if (e.endsWith(le)) {
					let t = u[o++], n = i.getAttribute(e).split(y), r = /([.?@])?(.*)/.exec(t);
					c.push({
						type: 1,
						index: a,
						name: r[2],
						strings: n,
						ctor: r[1] === "." ? xe : r[1] === "?" ? Se : r[1] === "@" ? Ce : F
					}), i.removeAttribute(e);
				} else e.startsWith(y) && (c.push({
					type: 6,
					index: a
				}), i.removeAttribute(e));
				if (ge.test(i.tagName)) {
					let e = i.textContent.split(y), t = e.length - 1;
					if (t > 0) {
						i.textContent = v ? v.emptyScript : "";
						for (let n = 0; n < t; n++) i.append(e[n], S()), j.nextNode(), c.push({
							type: 2,
							index: ++a
						});
						i.append(e[t], S());
					}
				}
			} else if (i.nodeType === 8) if (i.data === b) c.push({
				type: 2,
				index: a
			});
			else {
				let e = -1;
				for (; (e = i.data.indexOf(y, e + 1)) !== -1;) c.push({
					type: 7,
					index: a
				}), e += y.length - 1;
			}
			a++;
		}
	}
	static createElement(e, t) {
		let n = x.createElement("template");
		return n.innerHTML = e, n;
	}
};
function N(e, t, n = e, r) {
	if (t === k) return t;
	let i = r === void 0 ? n._$Cl : n._$Co?.[r], a = C(t) ? void 0 : t._$litDirective$;
	return i?.constructor !== a && (i?._$AO?.(!1), a === void 0 ? i = void 0 : (i = new a(e), i._$AT(e, n, r)), r === void 0 ? n._$Cl = i : (n._$Co ??= [])[r] = i), i !== void 0 && (t = N(e, i._$AS(e, t.values), i, r)), t;
}
var be = class {
	constructor(e, t) {
		this._$AV = [], this._$AN = void 0, this._$AD = e, this._$AM = t;
	}
	get parentNode() {
		return this._$AM.parentNode;
	}
	get _$AU() {
		return this._$AM._$AU;
	}
	u(e) {
		let { el: { content: t }, parts: n } = this._$AD, r = (e?.creationScope ?? x).importNode(t, !0);
		j.currentNode = r;
		let i = j.nextNode(), a = 0, o = 0, s = n[0];
		for (; s !== void 0;) {
			if (a === s.index) {
				let t;
				s.type === 2 ? t = new P(i, i.nextSibling, this, e) : s.type === 1 ? t = new s.ctor(i, s.name, s.strings, this, e) : s.type === 6 && (t = new we(i, this, e)), this._$AV.push(t), s = n[++o];
			}
			a !== s?.index && (i = j.nextNode(), a++);
		}
		return j.currentNode = x, r;
	}
	p(e) {
		let t = 0;
		for (let n of this._$AV) n !== void 0 && (n.strings === void 0 ? n._$AI(e[t]) : (n._$AI(e, n, t), t += n.strings.length - 2)), t++;
	}
}, P = class e {
	get _$AU() {
		return this._$AM?._$AU ?? this._$Cv;
	}
	constructor(e, t, n, r) {
		this.type = 2, this._$AH = A, this._$AN = void 0, this._$AA = e, this._$AB = t, this._$AM = n, this.options = r, this._$Cv = r?.isConnected ?? !0;
	}
	get parentNode() {
		let e = this._$AA.parentNode, t = this._$AM;
		return t !== void 0 && e?.nodeType === 11 && (e = t.parentNode), e;
	}
	get startNode() {
		return this._$AA;
	}
	get endNode() {
		return this._$AB;
	}
	_$AI(e, t = this) {
		e = N(this, e, t), C(e) ? e === A || e == null || e === "" ? (this._$AH !== A && this._$AR(), this._$AH = A) : e !== this._$AH && e !== k && this._(e) : e._$litType$ === void 0 ? e.nodeType === void 0 ? de(e) ? this.k(e) : this._(e) : this.T(e) : this.$(e);
	}
	O(e) {
		return this._$AA.parentNode.insertBefore(e, this._$AB);
	}
	T(e) {
		this._$AH !== e && (this._$AR(), this._$AH = this.O(e));
	}
	_(e) {
		this._$AH !== A && C(this._$AH) ? this._$AA.nextSibling.data = e : this.T(x.createTextNode(e)), this._$AH = e;
	}
	$(e) {
		let { values: t, _$litType$: n } = e, r = typeof n == "number" ? this._$AC(e) : (n.el === void 0 && (n.el = M.createElement(ve(n.h, n.h[0]), this.options)), n);
		if (this._$AH?._$AD === r) this._$AH.p(t);
		else {
			let e = new be(r, this), n = e.u(this.options);
			e.p(t), this.T(n), this._$AH = e;
		}
	}
	_$AC(e) {
		let t = _e.get(e.strings);
		return t === void 0 && _e.set(e.strings, t = new M(e)), t;
	}
	k(t) {
		w(this._$AH) || (this._$AH = [], this._$AR());
		let n = this._$AH, r, i = 0;
		for (let a of t) i === n.length ? n.push(r = new e(this.O(S()), this.O(S()), this, this.options)) : r = n[i], r._$AI(a), i++;
		i < n.length && (this._$AR(r && r._$AB.nextSibling, i), n.length = i);
	}
	_$AR(e = this._$AA.nextSibling, t) {
		for (this._$AP?.(!1, !0, t); e !== this._$AB;) {
			let t = se(e).nextSibling;
			se(e).remove(), e = t;
		}
	}
	setConnected(e) {
		this._$AM === void 0 && (this._$Cv = e, this._$AP?.(e));
	}
}, F = class {
	get tagName() {
		return this.element.tagName;
	}
	get _$AU() {
		return this._$AM._$AU;
	}
	constructor(e, t, n, r, i) {
		this.type = 1, this._$AH = A, this._$AN = void 0, this.element = e, this.name = t, this._$AM = r, this.options = i, n.length > 2 || n[0] !== "" || n[1] !== "" ? (this._$AH = Array(n.length - 1).fill(/* @__PURE__ */ new String()), this.strings = n) : this._$AH = A;
	}
	_$AI(e, t = this, n, r) {
		let i = this.strings, a = !1;
		if (i === void 0) e = N(this, e, t, 0), a = !C(e) || e !== this._$AH && e !== k, a && (this._$AH = e);
		else {
			let r = e, o, s;
			for (e = i[0], o = 0; o < i.length - 1; o++) s = N(this, r[n + o], t, o), s === k && (s = this._$AH[o]), a ||= !C(s) || s !== this._$AH[o], s === A ? e = A : e !== A && (e += (s ?? "") + i[o + 1]), this._$AH[o] = s;
		}
		a && !r && this.j(e);
	}
	j(e) {
		e === A ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, e ?? "");
	}
}, xe = class extends F {
	constructor() {
		super(...arguments), this.type = 3;
	}
	j(e) {
		this.element[this.name] = e === A ? void 0 : e;
	}
}, Se = class extends F {
	constructor() {
		super(...arguments), this.type = 4;
	}
	j(e) {
		this.element.toggleAttribute(this.name, !!e && e !== A);
	}
}, Ce = class extends F {
	constructor(e, t, n, r, i) {
		super(e, t, n, r, i), this.type = 5;
	}
	_$AI(e, t = this) {
		if ((e = N(this, e, t, 0) ?? A) === k) return;
		let n = this._$AH, r = e === A && n !== A || e.capture !== n.capture || e.once !== n.once || e.passive !== n.passive, i = e !== A && (n === A || r);
		r && this.element.removeEventListener(this.name, this, n), i && this.element.addEventListener(this.name, this, e), this._$AH = e;
	}
	handleEvent(e) {
		typeof this._$AH == "function" ? this._$AH.call(this.options?.host ?? this.element, e) : this._$AH.handleEvent(e);
	}
}, we = class {
	constructor(e, t, n) {
		this.element = e, this.type = 6, this._$AN = void 0, this._$AM = t, this.options = n;
	}
	get _$AU() {
		return this._$AM._$AU;
	}
	_$AI(e) {
		N(this, e);
	}
}, Te = _.litHtmlPolyfillSupport;
Te?.(M, P), (_.litHtmlVersions ??= []).push("3.3.2");
var Ee = (e, t, n) => {
	let r = n?.renderBefore ?? t, i = r._$litPart$;
	if (i === void 0) {
		let e = n?.renderBefore ?? null;
		r._$litPart$ = i = new P(t.insertBefore(S(), e), e, void 0, n ?? {});
	}
	return i._$AI(e), i;
}, I = globalThis, L = class extends g {
	constructor() {
		super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
	}
	createRenderRoot() {
		let e = super.createRenderRoot();
		return this.renderOptions.renderBefore ??= e.firstChild, e;
	}
	update(e) {
		let t = this.render();
		this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this._$Do = Ee(t, this.renderRoot, this.renderOptions);
	}
	connectedCallback() {
		super.connectedCallback(), this._$Do?.setConnected(!0);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this._$Do?.setConnected(!1);
	}
	render() {
		return k;
	}
};
L._$litElement$ = !0, L.finalized = !0, I.litElementHydrateSupport?.({ LitElement: L });
var De = I.litElementPolyfillSupport;
De?.({ LitElement: L }), (I.litElementVersions ??= []).push("4.2.2");
//#endregion
//#region ../../node_modules/@lit/reactive-element/decorators/custom-element.js
var R = (e) => (t, n) => {
	n === void 0 ? customElements.define(e, t) : n.addInitializer(() => {
		customElements.define(e, t);
	});
}, Oe = {
	attribute: !0,
	type: String,
	converter: m,
	reflect: !1,
	hasChanged: h
}, ke = (e = Oe, t, n) => {
	let { kind: r, metadata: i } = n, a = globalThis.litPropertyMetadata.get(i);
	if (a === void 0 && globalThis.litPropertyMetadata.set(i, a = /* @__PURE__ */ new Map()), r === "setter" && ((e = Object.create(e)).wrapped = !0), a.set(n.name, e), r === "accessor") {
		let { name: r } = n;
		return {
			set(n) {
				let i = t.get.call(this);
				t.set.call(this, n), this.requestUpdate(r, i, e, !0, n);
			},
			init(t) {
				return t !== void 0 && this.C(r, void 0, e, t), t;
			}
		};
	}
	if (r === "setter") {
		let { name: r } = n;
		return function(n) {
			let i = this[r];
			t.call(this, n), this.requestUpdate(r, i, e, !0, n);
		};
	}
	throw Error("Unsupported decorator location: " + r);
};
function z(e) {
	return (t, n) => typeof n == "object" ? ke(e, t, n) : ((e, t, n) => {
		let r = t.hasOwnProperty(n);
		return t.constructor.createProperty(n, e), r ? Object.getOwnPropertyDescriptor(t, n) : void 0;
	})(e, t, n);
}
//#endregion
//#region ../../node_modules/@lit/reactive-element/decorators/state.js
function B(e) {
	return z({
		...e,
		state: !0,
		attribute: !1
	});
}
//#endregion
//#region ../../node_modules/@lit/reactive-element/decorators/base.js
var Ae = (e, t, n) => (n.configurable = !0, n.enumerable = !0, Reflect.decorate && typeof t != "object" && Object.defineProperty(e, t, n), n);
//#endregion
//#region ../../node_modules/@lit/reactive-element/decorators/query.js
function je(e, t) {
	return (n, r, i) => {
		let a = (t) => t.renderRoot?.querySelector(e) ?? null;
		if (t) {
			let { get: e, set: t } = typeof r == "object" ? n : i ?? (() => {
				let e = Symbol();
				return {
					get() {
						return this[e];
					},
					set(t) {
						this[e] = t;
					}
				};
			})();
			return Ae(n, r, { get() {
				let n = e.call(this);
				return n === void 0 && (n = a(this), (n !== null || this.hasUpdated) && t.call(this, n)), n;
			} });
		}
		return Ae(n, r, { get() {
			return a(this);
		} });
	};
}
//#endregion
//#region src/components/modal/inmar-hc-modal.css?inline
var Me = o`:host{display:block}dialog{background:0 0;border:none;justify-content:center;align-items:center;width:100vw;max-width:none;height:100vh;max-height:none;padding:0;display:none}dialog[open]{display:flex}dialog::backdrop{background:#00000080}.content{width:100%;max-height:calc(100vh - var(--spacing-8));background:var(--color-white);border:1px solid var(--color-gray-200);border-radius:var(--radius-lg);box-shadow:var(--shadow-sm);padding:var(--spacing-4);flex-direction:column;display:flex}@media (width>=768px){.content{padding:var(--spacing-6)}}.modal--sm .content{max-width:var(--max-w-sm)}.modal--md .content{max-width:var(--max-w-2xl)}.modal--lg .content{max-width:var(--max-w-4xl)}.modal--full .content{max-width:calc(100vw - var(--spacing-8))}.header{padding-bottom:var(--spacing-4);margin-left:calc(var(--spacing-4) * -1);margin-right:calc(var(--spacing-4) * -1);padding-left:var(--spacing-4);padding-right:var(--spacing-4);border-bottom:1px solid var(--color-gray-200);justify-content:space-between;align-items:center;display:flex}@media (width>=768px){.header{margin-left:calc(var(--spacing-6) * -1);margin-right:calc(var(--spacing-6) * -1);padding-left:var(--spacing-6);padding-right:var(--spacing-6)}}.title{font-size:var(--text-xl);font-weight:var(--font-weight-medium);color:var(--color-gray-900);margin:0}.close-btn{width:var(--spacing-9);height:var(--spacing-9);color:var(--color-gray-400);cursor:pointer;box-shadow:none;background:0 0;border:none;border-radius:0;outline:none;justify-content:center;align-items:center;margin-inline-start:auto;display:inline-flex}.close-btn:hover{color:var(--color-gray-900);background:0 0}.close-btn:focus-visible{outline:2px solid var(--color-primary-400);outline-offset:1px}.close-btn:focus:not(:focus-visible){outline:none}.body{padding:var(--spacing-4) 0;flex:1;overflow-y:auto}.footer{align-items:center;gap:var(--spacing-4);padding-top:var(--spacing-4);margin-left:calc(var(--spacing-4) * -1);margin-right:calc(var(--spacing-4) * -1);padding-left:var(--spacing-4);padding-right:var(--spacing-4);border-top:1px solid var(--color-gray-200);display:flex}@media (width>=768px){.footer{margin-left:calc(var(--spacing-6) * -1);margin-right:calc(var(--spacing-6) * -1);padding-left:var(--spacing-6);padding-right:var(--spacing-6)}}.no-dividers .header,.no-dividers .footer{border:none;margin-left:0;margin-right:0;padding-left:0;padding-right:0}`;
//#endregion
//#region \0@oxc-project+runtime@0.122.0/helpers/decorate.js
function V(e, t, n, r) {
	var i = arguments.length, a = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, o;
	if (typeof Reflect == "object" && typeof Reflect.decorate == "function") a = Reflect.decorate(e, t, n, r);
	else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
	return i > 3 && a && Object.defineProperty(t, n, a), a;
}
//#endregion
//#region src/components/modal/inmar-hc-modal.ts
var H = class extends L {
	constructor(...e) {
		super(...e), this.open = !1, this.size = "md", this.modalTitle = "", this.backdropDismiss = !0, this.showClose = !0, this.showDividers = !0;
	}
	static {
		this.styles = [a(Me)];
	}
	updated(e) {
		e.has("open") && (this.open ? (this.updateComplete.then(() => {
			this._dialog && !this._dialog.open && this._dialog.showModal();
		}), this._emit("modal-opened")) : e.get("open") === !0 && this._emit("modal-closed"));
	}
	_requestClose() {
		this._emit("close", { cancelable: !0 }).defaultPrevented || (this.open = !1);
	}
	_emit(e, t) {
		let n = new CustomEvent(e, {
			bubbles: !0,
			composed: !0,
			...t
		});
		return this.dispatchEvent(n), n;
	}
	_onDialogClose() {
		this.open &&= !1;
	}
	_onKeydown(e) {
		e.key === "Escape" && (e.preventDefault(), this._requestClose());
	}
	_onBackdropClick(e) {
		if (!this.backdropDismiss) return;
		let t = this.shadowRoot?.querySelector(".content");
		if (!t) return;
		let n = t.getBoundingClientRect();
		n.top <= e.clientY && e.clientY <= n.top + n.height && n.left <= e.clientX && e.clientX <= n.left + n.width || this._requestClose();
	}
	render() {
		return this.open ? O`
      <dialog
        class="dialog modal--${this.size}"
        part="dialog"
        aria-labelledby=${this.modalTitle ? "modal-title" : A}
        @close=${this._onDialogClose}
        @click=${this._onBackdropClick}
        @keydown=${this._onKeydown}
      >
        <div
          class="content${this.showDividers ? "" : " no-dividers"}"
          part="content"
        >
          <div class="header" part="header">
            <slot name="header">
              ${this.modalTitle ? O`<h2 id="modal-title" class="title">
                    ${this.modalTitle}
                  </h2>` : A}
            </slot>
            ${this.showClose ? O`
                  <button
                    class="close-btn"
                    type="button"
                    @click=${() => this._requestClose()}
                    aria-label="Close"
                  >
                    <svg
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18 17.94 6M18 18 6.06 6"
                      />
                    </svg>
                  </button>
                ` : A}
          </div>

          <div class="body" part="body">
            <slot name="body"></slot>
            <slot></slot>
          </div>

          <div class="footer" part="footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </dialog>
    ` : A;
	}
};
V([je("dialog")], H.prototype, "_dialog", void 0), V([z({
	type: Boolean,
	reflect: !0
})], H.prototype, "open", void 0), V([z({
	type: String,
	reflect: !0
})], H.prototype, "size", void 0), V([z({
	type: String,
	attribute: "modal-title"
})], H.prototype, "modalTitle", void 0), V([z({
	type: Boolean,
	attribute: "backdrop-dismiss"
})], H.prototype, "backdropDismiss", void 0), V([z({
	type: Boolean,
	attribute: "show-close",
	reflect: !0
})], H.prototype, "showClose", void 0), V([z({
	type: Boolean,
	attribute: "show-dividers",
	reflect: !0
})], H.prototype, "showDividers", void 0), H = V([R("inmar-hc-modal")], H);
//#endregion
//#region ../../node_modules/lit-html/directive.js
var Ne = {
	ATTRIBUTE: 1,
	CHILD: 2,
	PROPERTY: 3,
	BOOLEAN_ATTRIBUTE: 4,
	EVENT: 5,
	ELEMENT: 6
}, Pe = (e) => (...t) => ({
	_$litDirective$: e,
	values: t
}), Fe = class {
	constructor(e) {}
	get _$AU() {
		return this._$AM._$AU;
	}
	_$AT(e, t, n) {
		this._$Ct = e, this._$AM = t, this._$Ci = n;
	}
	_$AS(e, t) {
		return this.update(e, t);
	}
	update(e, t) {
		return this.render(...t);
	}
}, U = Pe(class extends Fe {
	constructor(e) {
		if (super(e), e.type !== Ne.ATTRIBUTE || e.name !== "class" || e.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
	}
	render(e) {
		return " " + Object.keys(e).filter((t) => e[t]).join(" ") + " ";
	}
	update(e, [t]) {
		if (this.st === void 0) {
			this.st = /* @__PURE__ */ new Set(), e.strings !== void 0 && (this.nt = new Set(e.strings.join(" ").split(/\s/).filter((e) => e !== "")));
			for (let e in t) t[e] && !this.nt?.has(e) && this.st.add(e);
			return this.render(t);
		}
		let n = e.element.classList;
		for (let e of this.st) e in t || (n.remove(e), this.st.delete(e));
		for (let e in t) {
			let r = !!t[e];
			r === this.st.has(e) || this.nt?.has(e) || (r ? (n.add(e), this.st.add(e)) : (n.remove(e), this.st.delete(e)));
		}
		return k;
	}
}), Ie = (e) => e ?? A, Le = o`:host{display:inline-block}button{justify-content:center;align-items:center;gap:var(--spacing-2);border-radius:var(--radius-lg);font-family:var(--font-sans);font-weight:var(--font-weight-semibold);cursor:pointer;transition:background-color .1s var(--ease-in-out), color .1s var(--ease-in-out);white-space:nowrap;line-height:var(--leading-tight);border:none;display:inline-flex}button.size-xs{font-size:var(--text-xs);padding:var(--spacing-2) var(--spacing-3)}button.size-sm{font-size:var(--text-base);padding:var(--spacing-2) var(--spacing-3);letter-spacing:-.01rem}button.size-base{font-size:var(--text-base);padding:var(--spacing-3) var(--spacing-4);letter-spacing:-.01rem}button.size-lg{font-size:var(--text-lg);padding:var(--spacing-3) var(--spacing-5)}button.size-xl{font-size:var(--text-lg);padding:var(--spacing-3_5) var(--spacing-6)}button.icon-only.size-xs{padding:var(--spacing-1)}button.icon-only.size-sm{padding:var(--spacing-2)}button.icon-only.size-base,button.icon-only.size-lg{padding:var(--spacing-3)}button.icon-only.size-xl{padding:var(--spacing-3_5)}button.icon-only{border-radius:var(--radius-full)}button.variant-primary{background:var(--color-primary-100);color:var(--color-primary-800)}button.variant-primary:hover{background:var(--color-primary-800);color:var(--color-white)}button.variant-primary:focus-visible{outline:2px solid var(--color-primary-400);outline-offset:1px;background:var(--color-primary-800);color:var(--color-white)}button.variant-primary:disabled{background:var(--color-primary-50);color:var(--color-primary-300);cursor:not-allowed}button.variant-primary.color-white{background:var(--color-white)}button.variant-secondary{background:var(--color-white);color:var(--color-primary-800);border:1px solid var(--color-primary-800)}button.variant-secondary:hover{background:var(--color-primary-50)}button.variant-secondary:focus-visible{outline:2px solid var(--color-primary-400);background:var(--color-primary-50)}button.variant-secondary:disabled{border-color:var(--color-primary-300);color:var(--color-primary-300);opacity:1;cursor:not-allowed}button.variant-secondary:disabled:hover{background:var(--color-white)}button.variant-tertiary{background:var(--color-white);color:var(--color-primary-800)}button.variant-tertiary:hover{background:var(--color-primary-50)}button.variant-tertiary:focus-visible{outline:2px solid var(--color-primary-400);background:var(--color-primary-100)}button.variant-tertiary:disabled{color:var(--color-primary-300);opacity:1;cursor:not-allowed}button.variant-tertiary:disabled:hover{background:var(--color-white)}button.variant-danger{background:var(--color-red-500);color:var(--color-white)}button.variant-danger:hover{background:var(--color-red-700)}button.variant-danger:focus-visible{outline:2px solid var(--color-red-300);outline-offset:1px;background:var(--color-red-700)}button.variant-danger:disabled{background:var(--color-red-200);color:var(--color-white);opacity:1;cursor:not-allowed}button.variant-danger:disabled:hover{background:var(--color-red-200)}.icon{justify-content:center;align-items:center;width:1em;height:1em;display:flex}.icon ::slotted(svg){width:1.25em;height:1.25em}button.size-xs ::slotted([slot=left-icon]),button.size-xs ::slotted([slot=right-icon]){width:16px;height:16px;font-size:16px}button.size-sm ::slotted([slot=left-icon]),button.size-sm ::slotted([slot=right-icon]){width:20px;height:20px;font-size:20px}button.size-base ::slotted([slot=left-icon]),button.size-base ::slotted([slot=right-icon]){width:24px;height:24px;font-size:24px}.icon-only-container{width:var(--spacing-6);height:var(--spacing-6);place-items:center;display:grid}`, W = class extends L {
	constructor(...e) {
		super(...e), this.variant = "primary", this.size = "base", this.color = "primary", this.label = "", this.iconOnly = !1, this.disabled = !1, this.ariaLabel = "";
	}
	static {
		this.styles = [a(Le)];
	}
	static {
		this.shadowRootOptions = {
			...L.shadowRootOptions,
			delegatesFocus: !0
		};
	}
	willUpdate(e) {
		super.willUpdate(e), this.iconOnly && !this.ariaLabel && console.warn("[inmar-hc-button] iconOnly is set but no aria-label was provided. This makes the button inaccessible to screen readers.");
	}
	_onButtonClick() {
		if (this.disabled) return;
		let e = {
			textContent: this.label,
			element: this
		};
		this.dispatchEvent(new CustomEvent("button-click", {
			bubbles: !0,
			composed: !0,
			detail: e
		}));
	}
	render() {
		return O`
      <button
        type="button"
        part="button"
        class=${U({
			[`variant-${this.variant}`]: !0,
			[`size-${this.size}`]: !0,
			[`color-${this.color}`]: this.color !== "primary",
			"icon-only": this.iconOnly
		})}
        ?disabled=${this.disabled}
        aria-label=${Ie(this.iconOnly && !this.label ? this.ariaLabel || "Button" : void 0)}
        @click=${this._onButtonClick}
      >
        ${this.iconOnly ? O`
              <div class="icon-only-container">
                <slot name="icon"></slot>
              </div>
            ` : O`
              <slot name="left-icon"></slot>
              ${this.label}
              <slot name="right-icon"></slot>
            `}
      </button>
    `;
	}
};
V([z({
	type: String,
	reflect: !0
})], W.prototype, "variant", void 0), V([z({
	type: String,
	reflect: !0
})], W.prototype, "size", void 0), V([z({
	type: String,
	reflect: !0
})], W.prototype, "color", void 0), V([z({ type: String })], W.prototype, "label", void 0), V([z({
	type: Boolean,
	attribute: "icon-only"
})], W.prototype, "iconOnly", void 0), V([z({
	type: Boolean,
	reflect: !0
})], W.prototype, "disabled", void 0), V([z({
	type: String,
	attribute: "button-aria-label"
})], W.prototype, "ariaLabel", void 0), W = V([R("inmar-hc-button")], W);
//#endregion
//#region src/components/spinner/inmar-hc-spinner.css?inline
var Re = o`:host{vertical-align:middle;align-items:center;display:inline-flex}.variant-light .track{fill:var(--color-gray-200)}.variant-light .fill{fill:var(--color-primary-800)}.variant-dark .track{fill:var(--color-gray-700)}.variant-dark .fill{fill:var(--color-primary-400)}.size-small{width:50px;height:50px}.size-default{width:75px;height:75px}.size-large{width:100px;height:100px}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@media (prefers-reduced-motion:reduce){svg{animation:none}}svg{width:100%;height:100%;animation:1s linear infinite spin}`, G = class extends L {
	constructor(...e) {
		super(...e), this.size = "default", this.variant = "light", this.ariaLabel = "Loading";
	}
	static {
		this.styles = [a(Re)];
	}
	connectedCallback() {
		super.connectedCallback(), this.hasAttribute("role") || this.setAttribute("role", "status"), this.hasAttribute("aria-live") || this.setAttribute("aria-live", "polite");
	}
	render() {
		return O`
      <div class=${U({
			[`size-${this.size}`]: !0,
			[`variant-${this.variant}`]: !0
		})}>
        <svg
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            class="track"
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          />
          <path
            class="fill"
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          />
        </svg>
      </div>
    `;
	}
};
V([z({
	type: String,
	reflect: !0
})], G.prototype, "size", void 0), V([z({
	type: String,
	reflect: !0
})], G.prototype, "variant", void 0), V([z({
	type: String,
	attribute: "aria-label",
	reflect: !0
})], G.prototype, "ariaLabel", void 0), G = V([R("inmar-hc-spinner")], G);
//#endregion
//#region src/components/stepper/inmar-hc-stepper.css?inline
var ze = o`:host{display:block}.stepper{align-items:center;gap:var(--spacing-0);width:100%;min-height:24px;padding:var(--spacing-0);user-select:none;margin:0;display:flex}.step{align-items:center;gap:var(--spacing-2);white-space:nowrap;display:flex}.connector-polyline{border-top:2px solid var(--color-gray-300);min-width:100px;height:0;margin:0 var(--spacing-2) 0 0;flex:1 1 0}.circle-indicator{border-radius:var(--radius-full);width:24px;min-width:24px;height:24px;font-family:var(--font-sans);font-size:var(--text-sm);font-weight:var(--font-weight-normal);color:var(--color-gray-600);box-sizing:border-box;justify-content:center;align-items:center;line-height:1;display:inline-flex}.circle-indicator--completed{background:0 0;border:none}.circle-indicator--current{background:var(--color-primary-800);color:var(--color-white);border:none}.circle-indicator--upcoming{background:var(--color-white);border:1px solid var(--color-gray-400)}.check-circle-icon{width:24px;height:24px;color:var(--color-primary-800)}.label{font-family:var(--font-sans);font-size:var(--text-sm);font-weight:var(--font-weight-semibold);line-height:var(--leading-tight)}.label--completed{color:var(--color-primary-800);font-weight:var(--font-weight-normal)}.label--current{font-size:var(--text-base);font-weight:var(--font-weight-bold);color:var(--color-primary-800)}.label--upcoming{font-weight:var(--font-weight-normal);color:var(--color-gray-600)}`, K = class extends L {
	constructor(...e) {
		super(...e), this.steps = [], this.currentStep = 1;
	}
	static {
		this.styles = [a(ze)];
	}
	_getStepStatus(e) {
		let t = e + 1;
		return t < this.currentStep ? "completed" : t === this.currentStep ? "current" : "upcoming";
	}
	render() {
		return O`
      <ol class="stepper" aria-label="Progress">
        ${this.steps.map((e, t) => {
			let n = this._getStepStatus(t), r = t + 1, i = t === this.steps.length - 1;
			return O`
            <li
              class="step"
              aria-current=${Ie(n === "current" ? "step" : void 0)}
            >
              <span class="circle-indicator circle-indicator--${n}">
                ${n === "completed" ? O` <hcds-icon
                      name="check-circle"
                      family="classic"
                      icon-style="solid"
                      class="check-circle-icon"
                    ></hcds-icon>` : r}
              </span>
              <span
                class="label label--${n}"
                id="step-label-${r}"
              >
                ${e.label}
              </span>

              ${i ? "" : O`<span
                    class="connector-polyline ${n === "completed" ? "connector-polyline--completed" : ""}"
                    aria-hidden="true"
                  ></span>`}
            </li>
          `;
		})}
      </ol>
    `;
	}
};
V([z({ type: Array })], K.prototype, "steps", void 0), V([z({
	type: Number,
	attribute: "current-step",
	reflect: !0
})], K.prototype, "currentStep", void 0), K = V([R("inmar-hc-stepper")], K);
//#endregion
//#region src/components/upload-area/shared/upload-face-mixin.ts
function Be(e) {
	class t extends e {
		static {
			this.formAssociated = !0;
		}
		constructor(...e) {
			super(...e), this._selectedFile = null, this.name = "", this.required = !1, this.disabled = !1, typeof this.attachInternals == "function" && (this._internals = this.attachInternals());
		}
		get value() {
			return this._selectedFile?.name ?? "";
		}
		get files() {
			return this._selectedFile ? [this._selectedFile] : [];
		}
		get validity() {
			return this._internals?.validity ?? {};
		}
		_setFormValue(e) {
			this._internals && (e ? (this._internals.setFormValue(e, e.name), this._internals.setValidity({}), this._internals.ariaInvalid = "false") : (this._internals.setFormValue(null), this._internals.setValidity({}), this._internals.ariaInvalid = "false"));
		}
		_setValidationError(e) {
			this._internals && (this._internals.setValidity({ customError: !0 }, e, this.shadowRoot?.querySelector("input") ?? void 0), this._internals.ariaInvalid = "true");
		}
		formResetCallback() {
			this._selectedFile = null, this._internals && (this._internals.setFormValue(null), this._internals.setValidity({}), this._internals.ariaInvalid = "false"), this.requestUpdate();
		}
		formDisabledCallback(e) {
			this.disabled = e, this._internals && (this._internals.ariaDisabled = e ? "true" : "false");
		}
		updated(e) {
			super.updated(e), e.has("disabled") && (this.disabled ? this.setAttribute("aria-disabled", "true") : this.removeAttribute("aria-disabled"));
		}
	}
	return V([z({
		type: String,
		reflect: !0
	})], t.prototype, "name", void 0), V([z({
		type: Boolean,
		reflect: !0
	})], t.prototype, "required", void 0), V([z({
		type: Boolean,
		reflect: !0
	})], t.prototype, "disabled", void 0), t;
}
//#endregion
//#region src/components/upload-area/shared/upload-validator.ts
function Ve(e, t) {
	if (t.accept) {
		let n = t.accept.split(",").map((e) => e.trim().toLowerCase()), r = "." + e.name.split(".").pop()?.toLowerCase(), i = e.type.toLowerCase();
		if (!n.some((e) => e === i || e === r || e.endsWith("/*") && i.startsWith(e.replace("/*", "/")))) {
			let e = t.maxFileSize > 0 ? q(t.maxFileSize) : "";
			return {
				valid: !1,
				reason: "invalid-type",
				message: e ? `Your file must be a CSV with a maximum size of ${e}` : "Your file must be a CSV"
			};
		}
	}
	return t.maxFileSize > 0 && e.size > t.maxFileSize ? {
		valid: !1,
		reason: "invalid-size",
		message: `Your file must be a CSV with a maximum size of ${q(t.maxFileSize)}`
	} : { valid: !0 };
}
function q(e) {
	if (e < 1024) return `${e}B`;
	if (e < 1024 * 1024) {
		let t = e / 1024;
		return t % 1 == 0 ? `${t}KB` : `${t.toFixed(1)}KB`;
	}
	let t = e / (1024 * 1024);
	return t % 1 == 0 ? `${t}MB` : `${t.toFixed(1)}MB`;
}
//#endregion
//#region src/components/upload-area/inmar-hc-upload-area-drag.css?inline
var He = o`:host{font-family:var(--font-sans);--upload-zone-background:var(--color-gray-50);--upload-zone-border:var(--color-gray-300);--upload-zone-hover-background:var(--color-primary-50);--upload-zone-hover-border:var(--color-primary-700);--upload-button-background:var(--color-primary-100);--upload-button-text:var(--color-primary-800);--upload-text:var(--color-gray-600);display:block}:host([disabled]){pointer-events:none;cursor:not-allowed;--upload-zone-background:var(--color-gray-100);--upload-zone-border:var(--color-gray-300);--upload-button-background:var(--color-primary-50);--upload-button-text:var(--color-primary-300);--upload-text:var(--color-gray-400)}.native-file-input{clip:rect(0, 0, 0, 0);white-space:nowrap;border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}.drag-drop-shell{flex-direction:column;width:100%;display:flex}.upload-zone{width:100%;height:234px;padding:var(--spacing-12) 0;justify-content:center;align-items:center;gap:var(--spacing-2);border:2px dashed var(--upload-zone-border);border-radius:var(--radius-xl);background:var(--upload-zone-background);cursor:pointer;transition:border-color var(--default-transition-duration) var(--ease-in-out), background-color var(--default-transition-duration) var(--ease-in-out);box-sizing:border-box;flex-direction:column;display:flex;position:relative}.upload-zone.state-dragging,.upload-zone.state-default:hover{border-color:var(--upload-zone-hover-border);background:var(--upload-zone-hover-background)}.drag-drop-shell.state-uploaded{min-height:286px}.upload-zone.state-error,.upload-zone.state-error:hover{border-color:var(--color-red-600);background:var(--color-red-50)}:host(:user-invalid) .upload-zone{border-color:var(--color-red-600)}.drop-content{flex-direction:column;align-items:center;gap:0;width:248px;display:flex}.upload-icon{width:40px;height:40px;color:var(--upload-text);margin-bottom:var(--spacing-2);justify-content:center;align-items:center;font-size:34px;display:flex}.upload-zone.state-dragging .upload-icon,.upload-zone.state-default:hover .upload-icon{color:var(--upload-zone-hover-border)}.upload-zone.state-error .upload-icon{color:var(--color-gray-600)}.text-content{align-items:center;gap:var(--spacing-2);width:248px;margin-bottom:var(--spacing-2_5);flex-direction:column;display:flex}.instructional-text{width:248px;height:22px;font-size:var(--text-base);color:var(--upload-text);text-align:center;white-space:nowrap;line-height:22px;display:inline-block}.instructional-emphasis{font-weight:var(--font-weight-bold)}.instructional-secondary{font-weight:var(--font-weight-normal)}.file-type-text{width:236px;height:18px;font-size:var(--text-xs);color:var(--upload-text);text-align:center;white-space:nowrap;line-height:18px;display:block}.file-indicator{align-items:center;gap:var(--spacing-1);padding-top:var(--spacing-1_5);flex-direction:row;max-width:100%;min-height:24px;display:inline-flex}.file-icon{color:var(--upload-button-text);flex-shrink:0;justify-content:center;align-items:center;display:flex}.file-link{align-items:center;gap:var(--spacing-1);cursor:default;min-width:0;max-width:480px;color:var(--upload-button-text);background:0 0;border:none;padding:0;display:inline-flex}.file-name{font-size:var(--text-base);letter-spacing:-.01rem;color:var(--upload-button-text);line-height:24px;font-weight:var(--font-weight-semibold);text-overflow:ellipsis;white-space:nowrap;max-width:100%;text-decoration:none;display:inline-block;overflow:hidden}.error-message{align-items:center;gap:var(--spacing-2);font-size:var(--text-sm);color:var(--color-red-600);text-align:left;padding:var(--spacing-2) 0;display:flex}.error-icon{font-size:var(--text-sm);flex-shrink:0}.file-indicator inmar-hc-button::part(button):hover{background:var(--color-white)}`, J = ".csv", Y = ".csv files only", Ue = "(max 50MB)", X = 52428800, Z = class extends Be(L) {
	constructor(...e) {
		super(...e), this.state = "", this.showButton = !0, this.showRemoveAction = !0, this.allowNewUpload = !0, this.accept = J, this.instructionalText = "Click to upload", this.secondaryText = "or drag and drop", this.fileTypeText = Y, this.maxFileSizeLabel = Ue, this.buttonText = "Choose File", this.maxFileSize = X, this.ariaLabel = "Upload file", this.errorMessage = "", this.fileName = "", this._isDragging = !1, this._internalError = "", this._dragDepth = 0, this._dragLeaveRaf = null;
	}
	static {
		this.styles = [a(He)];
	}
	connectedCallback() {
		super.connectedCallback(), this.hasAttribute("role") || this.setAttribute("role", "region");
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this._dragLeaveRaf !== null && (cancelAnimationFrame(this._dragLeaveRaf), this._dragLeaveRaf = null);
	}
	get selectedFile() {
		return this._selectedFile;
	}
	get _resolvedFileName() {
		return this._selectedFile?.name ?? this.fileName;
	}
	get _currentState() {
		return this._internalError || this.errorMessage ? "error" : this._isDragging ? "dragging" : this._resolvedFileName ? "uploaded" : this.state && this.state !== "default" ? this.state : "default";
	}
	_onDragEnter(e) {
		e.preventDefault(), this._dragLeaveRaf !== null && (cancelAnimationFrame(this._dragLeaveRaf), this._dragLeaveRaf = null), this._dragDepth++, this._isDragging ||= !0;
	}
	_onDragOver(e) {
		e.preventDefault();
	}
	_onDragLeave(e) {
		e.preventDefault(), this._dragDepth = Math.max(0, this._dragDepth - 1), this._dragDepth === 0 && this._dragLeaveRaf === null && (this._dragLeaveRaf = requestAnimationFrame(() => {
			this._dragLeaveRaf = null, this._dragDepth === 0 && (this._isDragging = !1);
		}));
	}
	_onDrop(e) {
		e.preventDefault(), this._dragLeaveRaf !== null && (cancelAnimationFrame(this._dragLeaveRaf), this._dragLeaveRaf = null), this._dragDepth = 0, this._isDragging = !1;
		let t = Array.from(e.dataTransfer?.files || []);
		if (t.length > 1) {
			this.dispatchEvent(new CustomEvent("file-error", {
				bubbles: !0,
				composed: !0,
				detail: {
					file: t[0],
					reason: "multiple-files",
					message: "Only one file allowed",
					element: this
				}
			}));
			return;
		}
		let n = t[0];
		n && this._processFile(n);
	}
	_onBrowseClick() {
		this.disabled || this._openFilePicker();
	}
	_onZoneClick(e) {
		let t = e.target;
		t?.tagName !== "INPUT" && (t?.tagName === "INMAR-HC-BUTTON" || t?.closest?.("inmar-hc-button") || this._openFilePicker());
	}
	_onFileInputChange(e) {
		if (this.disabled) return;
		let t = e.target, n = t.files?.[0];
		n && this._processFile(n), t.value = "";
	}
	_onRemoveFile() {
		if (this.disabled) return;
		let e = this._selectedFile?.name ?? "";
		this._selectedFile = null, this.fileName = "", this._internalError = "", this._setFormValue(null), this.dispatchEvent(new CustomEvent("file-removed", {
			bubbles: !0,
			composed: !0,
			detail: {
				fileName: e,
				element: this
			}
		}));
	}
	_openFilePicker() {
		(this.shadowRoot?.querySelector("input[type=\"file\"]"))?.click();
	}
	_processFile(e) {
		let t = Ve(e, {
			accept: this.accept,
			maxFileSize: this.maxFileSize
		});
		if (!t.valid) {
			this._selectedFile = null, this.fileName = "", this._internalError = t.message, this._setValidationError(t.message), this.dispatchEvent(new CustomEvent("file-error", {
				bubbles: !0,
				composed: !0,
				detail: {
					file: e,
					reason: t.reason,
					message: t.message,
					element: this
				}
			}));
			return;
		}
		this._internalError = "", this.errorMessage = "", this._selectedFile = e, this.fileName = e.name, this._setFormValue(e), this.dispatchEvent(new CustomEvent("file-selected", {
			bubbles: !0,
			composed: !0,
			detail: {
				file: e,
				element: this
			}
		}));
	}
	render() {
		let e = this._currentState, t = {
			"drag-drop-shell": !0,
			[`state-${e}`]: !0
		}, n = {
			"upload-zone": !0,
			[`state-${e}`]: !0
		};
		return O`
      <div class=${U(t)}>
        <div
          class=${U(n)}
          @click=${this._onZoneClick}
          @dragenter=${this._onDragEnter}
          @dragover=${this._onDragOver}
          @dragleave=${this._onDragLeave}
          @drop=${this._onDrop}
        >
          <input
            class="native-file-input"
            type="file"
            accept=${this.accept ?? ""}
            tabindex="-1"
            aria-hidden="true"
            ?disabled=${this.disabled}
            @change=${this._onFileInputChange}
          />
          <div class="drop-content">
            <span class="upload-icon">
              <hcds-icon
                name="upload"
                family="classic"
                icon-style="light"
              ></hcds-icon>
            </span>
            <div class="text-content">
              <span class="instructional-text">
                <span class="instructional-emphasis"
                  >${this.instructionalText}</span
                >
                <span class="instructional-secondary">
                  ${this.secondaryText}</span
                >
              </span>
              <span class="file-type-text"
                >${this.fileTypeText} ${this.maxFileSizeLabel}</span
              >
            </div>
            ${this.showButton ? O`<inmar-hc-button
                  variant="primary"
                  size="xs"
                  label=${this.buttonText}
                  ?disabled=${this.disabled}
                  @button-click=${this._onBrowseClick}
                ></inmar-hc-button>` : A}
          </div>
        </div>
        ${e === "uploaded" && this._resolvedFileName ? this._renderFileIndicator() : A}
        ${this._internalError || this.errorMessage ? O`<div class="error-message" role="alert">
              <hcds-icon
                name="diamond-exclamation"
                family="classic"
                icon-style="light"
              ></hcds-icon>
              ${this._internalError || this.errorMessage}
            </div>` : A}
      </div>
    `;
	}
	_renderFileIndicator() {
		return O`
      <div class="file-indicator">
        <div class="file-link">
          <span class="file-icon">
            <hcds-icon
              name="paperclip"
              family="classic"
              icon-style="light"
            ></hcds-icon>
          </span>
          <span class="file-name">${this._resolvedFileName}</span>
        </div>
        ${this.showRemoveAction && this.allowNewUpload && this._resolvedFileName ? O`<inmar-hc-button
              variant="tertiary"
              size="xs"
              icon-only
              button-aria-label="Remove file ${this._resolvedFileName}"
              ?disabled=${this.disabled}
              @button-click=${this._onRemoveFile}
            >
              <hcds-icon
                slot="icon"
                name="xmark"
                family="classic"
                icon-style="light"
              ></hcds-icon>
            </inmar-hc-button>` : A}
      </div>
    `;
	}
};
V([z({
	type: String,
	reflect: !0
})], Z.prototype, "state", void 0), V([z({
	type: Boolean,
	attribute: "show-button"
})], Z.prototype, "showButton", void 0), V([z({
	type: Boolean,
	attribute: "show-remove-action"
})], Z.prototype, "showRemoveAction", void 0), V([z({
	type: Boolean,
	attribute: "allow-new-upload"
})], Z.prototype, "allowNewUpload", void 0), V([z({ type: String })], Z.prototype, "accept", void 0), V([z({
	type: String,
	attribute: "instructional-text"
})], Z.prototype, "instructionalText", void 0), V([z({
	type: String,
	attribute: "secondary-text"
})], Z.prototype, "secondaryText", void 0), V([z({
	type: String,
	attribute: "file-type-text"
})], Z.prototype, "fileTypeText", void 0), V([z({
	type: String,
	attribute: "max-file-size-label"
})], Z.prototype, "maxFileSizeLabel", void 0), V([z({
	type: String,
	attribute: "button-text"
})], Z.prototype, "buttonText", void 0), V([z({
	type: Number,
	attribute: "max-file-size"
})], Z.prototype, "maxFileSize", void 0), V([z({
	type: String,
	attribute: "aria-label",
	reflect: !0
})], Z.prototype, "ariaLabel", void 0), V([z({
	type: String,
	attribute: "error-message"
})], Z.prototype, "errorMessage", void 0), V([z({
	type: String,
	attribute: "file-name"
})], Z.prototype, "fileName", void 0), V([B()], Z.prototype, "_isDragging", void 0), V([B()], Z.prototype, "_internalError", void 0), Z = V([R("inmar-hc-upload-area-drag")], Z);
//#endregion
//#region src/components/upload-area/inmar-hc-upload-area-button.css?inline
var We = o`:host{font-family:var(--font-sans);--upload-zone-border:var(--color-gray-400);--upload-zone-hover-border:var(--color-primary-700);--upload-button-text:var(--color-primary-800);--upload-text:var(--color-gray-500);display:block}:host([disabled]){pointer-events:none;cursor:not-allowed;--upload-zone-border:var(--color-gray-300);--upload-button-text:var(--color-primary-300);--upload-text:var(--color-gray-400)}.native-file-input{clip:rect(0, 0, 0, 0);white-space:nowrap;border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}.default-type-shell.size-default,.default-type-shell.size-large{width:536px}.upload-zone{border:1px solid var(--upload-zone-border);border-radius:var(--radius-xl);background:var(--color-gray-50);flex-direction:row;align-items:stretch;padding:0;display:flex;position:relative;overflow:hidden}.upload-zone.size-default{box-sizing:border-box;width:536px;min-height:40px}.upload-zone.size-large{box-sizing:border-box;width:536px;min-height:54px}.picker-section{border-right:1px solid var(--upload-zone-border);flex-shrink:0;align-items:stretch;display:flex}.picker-section>inmar-hc-button{height:100%;display:block}.picker-section inmar-hc-button::part(button){height:100%;padding:var(--spacing-2) 19px var(--spacing-2) var(--spacing-5);border-radius:0}.upload-zone.size-large .picker-section inmar-hc-button::part(button){padding:var(--spacing-4) 19px var(--spacing-4) var(--spacing-5);font-size:var(--text-base)}.default-file-field{min-width:0;padding:var(--spacing-2) var(--spacing-4);color:var(--upload-text);font-size:var(--text-sm);white-space:nowrap;text-overflow:ellipsis;cursor:pointer;flex:1;align-items:center;line-height:20px;display:flex;overflow:hidden}.selected-file-name{font-size:inherit;color:var(--color-gray-900);font-weight:var(--font-weight-normal)}:host(:user-invalid) .upload-zone{background:0 0;border:none;overflow:visible}:host(:user-invalid) .upload-zone .picker-section{border:1px solid var(--upload-zone-border);border-radius:var(--radius-xl) 0 0 var(--radius-xl);border-right:none;overflow:hidden}:host(:user-invalid) .upload-zone .default-file-field{background:var(--color-red-50);border:1px solid var(--color-red-600);border-radius:0 var(--radius-xl) var(--radius-xl) 0}.upload-zone.error{--upload-text:var(--color-red-600);background:0 0;border:none;overflow:visible}.upload-zone.error .picker-section{border:1px solid var(--upload-zone-border);border-radius:var(--radius-xl) 0 0 var(--radius-xl);border-right:none;overflow:hidden}.upload-zone.error .default-file-field{background:var(--color-red-50);border:1px solid var(--color-red-600);border-radius:0 var(--radius-xl) var(--radius-xl) 0}.upload-zone.size-large .default-file-field{font-size:var(--text-base);line-height:24px}.remove-section{padding:0 var(--spacing-2) 0 0;flex-shrink:0;align-items:center;display:flex}.remove-section inmar-hc-button::part(button){background:var(--color-gray-50);color:var(--color-gray-500);align-items:center}.remove-section inmar-hc-button::part(button):hover{background:var(--color-gray-50);color:var(--color-gray-600);align-items:center}.error-message{align-items:center;gap:var(--spacing-2);font-size:var(--text-sm);color:var(--color-red-600);text-align:left;padding:var(--spacing-2) 0;display:flex}.error-icon{font-size:var(--text-sm);flex-shrink:0}`, Q = class extends Be(L) {
	constructor(...e) {
		super(...e), this.size = "default", this.accept = J, this.chooseFileText = "Choose File", this.noFileText = "No file chosen", this.fileTypeText = Y, this.maxFileSize = X, this.ariaLabel = "Upload file", this.errorMessage = "", this.fileName = "", this._internalError = "";
	}
	static {
		this.styles = [a(We)];
	}
	connectedCallback() {
		super.connectedCallback(), this.hasAttribute("role") || this.setAttribute("role", "region");
	}
	get selectedFile() {
		return this._selectedFile;
	}
	get _resolvedFileName() {
		return this._selectedFile?.name ?? this.fileName;
	}
	_onBrowseClick() {
		this.disabled || this._openFilePicker();
	}
	_onFileInputChange(e) {
		if (this.disabled) return;
		let t = e.target, n = t.files?.[0];
		n && this._processFile(n), t.value = "";
	}
	_onRemoveFile() {
		if (this.disabled) return;
		let e = this._selectedFile?.name ?? "";
		this._selectedFile = null, this.fileName = "", this._internalError = "", this._setFormValue(null), this.dispatchEvent(new CustomEvent("file-removed", {
			bubbles: !0,
			composed: !0,
			detail: {
				fileName: e,
				element: this
			}
		}));
	}
	_openFilePicker() {
		(this.shadowRoot?.querySelector("input[type=\"file\"]"))?.click();
	}
	_processFile(e) {
		let t = Ve(e, {
			accept: this.accept,
			maxFileSize: this.maxFileSize
		});
		if (!t.valid) {
			this._selectedFile = null, this.fileName = "", this._internalError = t.message, this._setValidationError(t.message), this.dispatchEvent(new CustomEvent("file-error", {
				bubbles: !0,
				composed: !0,
				detail: {
					file: e,
					reason: t.reason,
					element: this
				}
			}));
			return;
		}
		this._internalError = "", this.errorMessage = "", this._selectedFile = e, this.fileName = e.name, this._setFormValue(e), this.dispatchEvent(new CustomEvent("file-selected", {
			bubbles: !0,
			composed: !0,
			detail: {
				file: e,
				element: this
			}
		}));
	}
	render() {
		let e = this.size === "large" ? "size-large" : "size-default", t = !!(this._internalError || this.errorMessage);
		return O`
      <div class="default-type-shell ${e}">
        <div class="upload-zone ${e} ${t ? "error" : ""}">
          <input
            class="native-file-input"
            type="file"
            accept=${this.accept ?? ""}
            tabindex="-1"
            aria-hidden="true"
            ?disabled=${this.disabled}
            @change=${this._onFileInputChange}
          />
          <div class="picker-section">
            <inmar-hc-button
              variant="primary"
              size=${this.size === "large" ? "sm" : "xs"}
              label=${this.chooseFileText}
              ?disabled=${this.disabled}
              @button-click=${this._onBrowseClick}
            ></inmar-hc-button>
          </div>
          <div
            class="default-file-field"
            aria-hidden="true"
            @click=${this._openFilePicker}
          >
            ${this._resolvedFileName ? O`<span class="selected-file-name"
                  >${this._resolvedFileName}</span
                >` : this.noFileText}
          </div>
          ${this._resolvedFileName ? O`<div class="remove-section">
                <inmar-hc-button
                  variant="tertiary"
                  size="xs"
                  icon-only
                  button-aria-label="Remove file ${this._resolvedFileName}"
                  ?disabled=${this.disabled}
                  @button-click=${this._onRemoveFile}
                >
                  <hcds-icon
                    slot="icon"
                    name="xmark"
                    family="classic"
                    icon-style="light"
                  ></hcds-icon>
                </inmar-hc-button>
              </div>` : A}
        </div>
        ${t ? O`<div class="error-message" role="alert">
              <hcds-icon
                name="diamond-exclamation"
                family="classic"
                icon-style="light"
              ></hcds-icon>
              ${this._internalError || this.errorMessage}
            </div>` : A}
      </div>
    `;
	}
};
V([z({
	type: String,
	reflect: !0
})], Q.prototype, "size", void 0), V([z({ type: String })], Q.prototype, "accept", void 0), V([z({
	type: String,
	attribute: "choose-file-text"
})], Q.prototype, "chooseFileText", void 0), V([z({
	type: String,
	attribute: "no-file-text"
})], Q.prototype, "noFileText", void 0), V([z({
	type: String,
	attribute: "file-type-text"
})], Q.prototype, "fileTypeText", void 0), V([z({
	type: Number,
	attribute: "max-file-size"
})], Q.prototype, "maxFileSize", void 0), V([z({
	type: String,
	attribute: "aria-label",
	reflect: !0
})], Q.prototype, "ariaLabel", void 0), V([z({
	type: String,
	attribute: "error-message"
})], Q.prototype, "errorMessage", void 0), V([z({
	type: String,
	attribute: "file-name"
})], Q.prototype, "fileName", void 0), V([B()], Q.prototype, "_internalError", void 0), Q = V([R("inmar-hc-upload-area-button")], Q);
//#endregion
//#region src/components/alert/inmar-hc-alert.css?inline
var Ge = o`:host{display:block}.alert{box-sizing:border-box;gap:var(--spacing-3);width:100%;padding:var(--spacing-4);border-radius:var(--radius-lg);color:var(--color-gray-900);border:1px solid #0000;flex-direction:column;display:flex}.alert--error{background:var(--color-red-50);border-color:var(--color-red-600)}.alert--warning{background:var(--color-orange-50);border-color:var(--color-orange-600)}.alert--info{background:var(--color-gray-200);border-color:var(--color-gray-600)}.alert--success{background:var(--color-green-50);border-color:var(--color-green-500)}.alert--notice{background:var(--color-yellow-50);border-color:var(--color-yellow-500)}.alert--success .alert-icon{color:var(--color-green-500)}.alert-heading{align-items:center;gap:var(--spacing-2);display:flex}.alert-icon{width:var(--spacing-5);height:var(--spacing-5);color:var(--color-gray-900);font-size:var(--text-base);flex:none}.alert-title{font-family:var(--font-sans);font-size:var(--text-lg);font-weight:var(--font-weight-normal);line-height:var(--leading-normal);color:var(--color-gray-900);margin:0}.alert-message{font-family:var(--font-sans);font-size:var(--text-sm);font-weight:var(--font-weight-normal);line-height:var(--leading-normal);color:var(--color-gray-900);margin:0}`, $ = class extends L {
	constructor(...e) {
		super(...e), this.type = "error", this.headingText = "", this.bodyText = "";
	}
	static {
		this.styles = [a(Ge)];
	}
	_iconName() {
		switch (this.type) {
			case "error": return "diamond-exclamation";
			case "warning": return "triangle-exclamation";
			case "info": return "circle-info";
			case "success": return "circle-check";
			case "notice": return "flag";
		}
	}
	render() {
		return O`
      <div class="alert alert--${this.type}" role="alert">
        <div class="alert-heading">
          <hcds-icon
            class="alert-icon"
            name=${this._iconName()}
            family="classic"
            icon-style="light"
            aria-hidden="true"
          ></hcds-icon>
          ${this.headingText ? O`<h3 class="alert-title">${this.headingText}</h3>` : A}
        </div>
        ${this.bodyText ? O`<p class="alert-message">${this.bodyText}</p>` : A}
      </div>
    `;
	}
};
V([z({
	type: String,
	reflect: !0
})], $.prototype, "type", void 0), V([z({
	type: String,
	attribute: "heading-text"
})], $.prototype, "headingText", void 0), V([z({
	type: String,
	attribute: "body-text"
})], $.prototype, "bodyText", void 0), $ = V([R("inmar-hc-alert")], $);
//#endregion
export { J as DEFAULT_ACCEPTED_FILE_TYPE, Y as DEFAULT_FILE_TYPE_TEXT, X as DEFAULT_MAX_FILE_SIZE, Ue as DEFAULT_MAX_FILE_SIZE_LABEL, $ as InmarHcAlert, W as InmarHcButton, H as InmarHcModal, G as InmarHcSpinner, K as InmarHcStepper, Q as InmarHcUploadAreaButton, Z as InmarHcUploadAreaDrag, q as formatFileSize };

//# sourceMappingURL=component-lib.js.map